import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";

const MyTeamLeaveBenefitTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">Employee</div>,
      dataIndex: "employee",
      key: "employee",
    },
    {
      title: <div className="text-table">Annual Leave</div>,
      dataIndex: "annualLeave",
      key: "annualLeave",
    },
    {
      title: <div className="text-table">Business Leave (without pay)</div>,
      dataIndex: "businessLeaveWitoutPay",
      key: "businessLeaveWitoutPay",
    },
    {
      title: <div className="text-table">Sick Leave (without pay)</div>,
      dataIndex: "sickLeaveWithoutPay",
      key: "sickLeaveWithoutPay",
    },
    {
      title: <div className="text-table">Business Leave</div>,
      dataIndex: "businessLeave",
      key: "businessLeave",
    },
    {
      title: <div className="text-table">Military Service Leave</div>,
      dataIndex: "militaryServiceLeave",
      key: "militaryServiceLeave",
    },
    {
      title: <div className="text-table">Ordination Leave</div>,
      dataIndex: "ordinationLeave",
      key: "ordinationLeave",
    },
    {
      title: <div className="text-table">Sterilization</div>,
      dataIndex: "sterilization",
      key: "sterilization",
    },
    {
      title: <div className="text-table">Training Leave</div>,
      dataIndex: "trainingLeave",
      key: "trainingLeave",
    },
    {
      title: <div className="text-table">Sick Leave</div>,
      dataIndex: "sickLeave",
      key: "sickLeave",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
};

export default MyTeamLeaveBenefitTable;
